import { useState, forwardRef } from "react";
import { useLanguage } from "../../context/LanguageContext";
import PropTypes from "prop-types";

const InputFile = forwardRef(
  ({ label, onChange, placeholder, error, ...props }, ref) => {
    const [fileName, setFileName] = useState("");
    const { copy } = useLanguage();

    const handleFileChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        setFileName(file.name);
      }
      if (onChange) {
        onChange(event);
      }
    };

    return (
      <div className="flex flex-col gap-1">
        {label && (
          <label className="text-left text-base md:text-sm font-medium">
            {label}
          </label>
        )}
        <div className="relative rounded-md">
          {/* Invisible file input */}
          <input
            type="file"
            onChange={handleFileChange}
            placeholder={placeholder}
            className="w-full text-sm px-4 py-2 input-base transition opacity-0 absolute inset-0 cursor-pointer"
            {...props}
          />

          {/* Visible button-like label */}
          <button
            type="button"
            className={`w-full text-base md:text-sm px-4 py-2 input-base bg-white rounded-md text-left cursor-pointer transition 
            ${
              error
                ? "border border-red-500 focus:ring-red-500 focus:border-red-500"
                : "border card-base-border focus:ring-blue-500 focus:border-blue-500"
            }
          `}
          >
            {fileName ? fileName : copy.card_wishlist.button_file}
          </button>
        </div>
        {error && <p className="text-red-500! text-xs mt-1">{error}</p>}
      </div>
    );
  }
);

InputFile.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
};

InputFile.displayName = "InputFile";

export default InputFile;
